/** localStorage getter can throw SecurityError when storage is blocked (ITP, WebView, strict privacy). */
export const getLocalStorage = (): Storage | null => {
	if (typeof window === 'undefined') {
		return null
	}

	try {
		return window.localStorage
	} catch {
		return null
	}
}

export const getLocalStorageItem = (key: string): string | null => {
	const storage = getLocalStorage()
	if (!storage) {
		return null
	}

	try {
		return storage.getItem(key)
	} catch {
		return null
	}
}
